export default __webpack_public_path__ + "static/media/events.c7efbc08.svg";